// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__115Yt","editIcon":"style_editIcon__2QxG9","deletedIcon":"style_deletedIcon__3xCWP","newIcon":"style_newIcon__3hHaI"};